import createCrudVuexModule from "@/store/crud";

export const organizationAudit = createCrudVuexModule({
  namespaced: true,
  path: "/audit-control/audit",
  moduleName: "organizationAudit",
  options: {
    localizedFields: ["name", "description", "plannedResource", "realResource"],
  },
  state: {
    isDownloading: false,
    activeTab: "ORGANIZATION_AUDITS",
    activeSubTab: "IN_PROGRESS",
  },
  getters: {
    isDownloading: (state) => state.isDownloading,
    activeTab: (state) => state.activeTab,
    activeSubTab: (state) => state.activeSubTab,
  },
  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),
    activeTab: (state, value) => (state.activeTab = value),
    activeSubTab: (state, value) => (state.activeSubTab = value),
  },
  actions: {},
});
